import { createFileRoute, Link } from '@tanstack/react-router'
import { useState } from 'react'
import { useCustomers, useCustomer360 } from '@/hooks/data/useCrm'

function CrmPage() {
  const customers = useCustomers()
  const [selected, setSelected] = useState<string | undefined>()
  const dash = useCustomer360(selected)

  return (
    <div className="grid grid-cols-1 gap-6 p-6 lg:grid-cols-3">
      <div className="lg:col-span-1">
        <h1 className="mb-4 text-xl font-semibold text-gray-900">Customers</h1>
        <div className="space-y-1">
          {customers.data?.map((c) => (
            <button key={c.id} onClick={() => setSelected(c.id)} className={`block w-full rounded px-3 py-2 text-left text-sm ${selected === c.id ? 'bg-blue-50 text-blue-700' : 'hover:bg-gray-50'}`}>
              <span className="font-medium">{c.name}</span>
              <span className="block text-xs text-gray-500">{c.suburb}</span>
            </button>
          ))}
        </div>
      </div>
      <div className="lg:col-span-2">
        {!selected && <p className="text-sm text-gray-500">Select a customer to see their 360° view.</p>}
        {selected && dash.isLoading && <p className="text-sm text-gray-500">Loading 360° view…</p>}
        {dash.data && (
          <div className="rounded-lg border border-gray-100 bg-white p-5 shadow-sm">
            <h2 className="text-lg font-semibold text-gray-900">{dash.data.customer.name}</h2>
            <p className="text-sm text-gray-500">{dash.data.customer.email} · {dash.data.customer.phone}</p>
            <div className="mt-4 grid grid-cols-3 gap-4 text-center">
              <div><p className="text-2xl font-semibold">{dash.data.bookings?.items.length ?? 0}</p><p className="text-xs text-gray-500">Bookings</p></div>
              <div><p className="text-2xl font-semibold">{dash.data.jobs?.length ?? 0}</p><p className="text-xs text-gray-500">Jobs</p></div>
              <div><p className="text-2xl font-semibold">{dash.data.invoices?.length ?? 0}</p><p className="text-xs text-gray-500">Invoices</p></div>
            </div>
            {dash.data.degradedSources.length > 0 && <p className="mt-3 text-xs text-amber-600">Partial view — unavailable: {dash.data.degradedSources.join(', ')}</p>}

            {dash.data.bookings && dash.data.bookings.items.length > 0 && (
              <div className="mt-5">
                <h3 className="text-sm font-semibold text-gray-700 mb-2">Bookings</h3>
                <div className="space-y-1">
                  {dash.data.bookings.items.map((bk) => (
                    <Link
                      key={bk.id}
                      to="/bookings/$id"
                      params={{ id: bk.id }}
                      className="flex items-center justify-between rounded px-3 py-2 text-sm hover:bg-gray-50"
                    >
                      <span>{bk.serviceType} · {bk.suburb}</span>
                      <span className="text-xs text-gray-500">{bk.status}</span>
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export const Route = createFileRoute('/(admin)/crm/')({ component: CrmPage })
